import { TypePosition } from '../../interfaces/TypePosition'
import { TypePositionAction } from '../actions/typePositionActions'
import { GET_TYPE_POSITION_EXITO } from '../types/typePositionActionsTypes'

export interface TypePositionState {
  typePositionsState: {
    typePositions?: TypePosition[] | undefined
    error?: string | undefined
  }
}

const initialState: TypePositionState = {
  typePositionsState: { typePositions: [], error: '' }
}

export const typePositionReducer = (
  state: TypePositionState = initialState,
  action: TypePositionAction
): TypePositionState => {
  if (action.type === GET_TYPE_POSITION_EXITO) {
    return {
      ...state,
      typePositionsState: {
        typePositions: action.typePositions,
        error: action.error
      }
    }
  }
  return state
}
